import { ListItem, ListItemSecondaryAction, ListItemText, Skeleton } from '@mui/material';
import { CopyButton } from '../Button/CopyButton';
import { ReactNode } from 'react';
import { LocalizedError, UiError } from './ErrorListItem';

export type RequisiteListItemProps = {
  title: string;
  value: ReactNode | undefined;
  valueToCopy?: string;
  error?: UiError | string | null | undefined;
  loading?: boolean;
  button?: ReactNode;
  actions?: ReactNode;
};

export function RequisiteListItem({
  title,
  value,
  valueToCopy,
  error,
  loading,
  button,
  actions,
}: RequisiteListItemProps) {
  const copyButtonValue = valueToCopy ?? (typeof value === 'string' ? value : undefined);

  return (
    <ListItem>
      <ListItemText
        primary={title}
        secondary={
          loading ? (
            <Skeleton />
          ) : error ? (
            typeof error === 'string' ? (
              error
            ) : (
              <LocalizedError error={error} />
            )
          ) : (
            value
          )
        }
        slotProps={{
          primary: { color: 'text.secondary' },

          secondary: {
            color: error ? 'text.secondary' : 'text.primary',
            sx: {
              wordBreak: 'break-word',
            },
          },
        }}
      />
      <ListItemSecondaryAction>
        {loading
          ? null
          : (button ??
            (copyButtonValue ? (
              <>
                {actions}
                <CopyButton value={copyButtonValue} />
              </>
            ) : undefined))}
      </ListItemSecondaryAction>
    </ListItem>
  );
}
